import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { ContactAcquiredModal } from "./uiParts/ContactAcquiredModal";
import { type ContactAcquiredModalProps } from "./type";
import * as styles from "./styles.css";

type Props = {
  isShow: boolean;
  isPrimary: boolean;
  isChecked: boolean;
  isPossibleToSubmit: boolean;
  handleShowModal: () => void;
  handleCloseModal: () => void;
  handleChangeCheckbox: () => void;
  handleRequestProfile: () => void;
} & ContactAcquiredModalProps;

export const Presentation: FC<Props> = (props) => {
  const { isPrimary, handleShowModal, isShow, entryId } = props;
  return (
    <>
      <div className={styles.buttonOuter}>
        <Button
          theme={isPrimary ? "primary" : "secondary"}
          onClick={handleShowModal}
          data-ga-category="Show"
          data-ga-action="job_entry_contacts_modal"
          data-step="contact_acquired"
          data-ga-label={entryId}
          data-entry_id={entryId}
          id={entryId}
        >
          連絡先を取得する
        </Button>
      </div>
      {isShow && <ContactAcquiredModal {...props} />}
    </>
  );
};
